import { styled } from "styled-components";

export const MainSlideContainer = styled.div`
  position: relative;
  height: 55vw;
  .inner {
    height: 100%;
  }
  @media all and (max-width: 768px) {
    height: 75vw;
  }
`;

export const HomeMainSlideWrapper = styled.div`
  height: 55vw;
  @media all and (max-width: 768px) {
    height: 75vw;
  }
`;

export const HomeMainSlideImgWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const HomeMainSlideTextWrapper = styled.div`
  height: 100%;
`;
export const HomeMainSlideTextWrap = styled.div`
  height: 100%;
  z-index: 1;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
  align-items: flex-start;
  > div {
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    align-items: flex-start;
  }
  .title-wrap {
    p {
      font-size: 40px;
      line-height: 1.4;
      color: #fbfbfb;
      font-weight: bold;
      text-align: left;
    }
  }
  span {
    font-size: 32px;
    line-height: 1.4;
    color: #fbfbfb;
    font-weight: bold;
    text-align: left;
  }
  @media all and (max-width: 768px) {
    gap: 1.563vw;
    > div {
      gap: 1.563vw;
    }
    .title-wrap {
      p {
        font-size: 6.25vw;
      }
    }
    span {
      font-size: 5.729vw;
    }
  }
`;

export const MainSlideButtonWrapper = styled.div`
  position: absolute;
  bottom: 20px;
  right: 0;
  width: 100%;
  z-index: 1;
  .inner {
    position: relative;
  }
  @media all and (max-width: 768px) {
    bottom: 3.906vw;
  }
`;

export const MainSlideButtonWrap = styled.div`
  position: absolute;
  bottom: 40px;
  right: 0;
  z-index: 1;
  display: flex;
  right: 0;
  gap: 20px;
  @media all and (max-width: 1180px) {
    bottom: 2.604vw;
    right: 40px;
  }
  @media all and (max-width: 768px) {
    right: 3.906vw;
    gap: 2.604vw;
  }
`;

export const MainSlidPrevButton = styled.button`
  width: 56px;
  height: 56px;
  background: rgba(0, 0, 0, 0.6);
  border: 0 none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  > i {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    width: 40px;
    height: 40px;
  }
  @media all and (max-width: 900px) {
    width: 48px;
    height: 48px;
    img {
      width: 32px;
      height: 32px;
    }
  }
  @media all and (max-width: 768px) {
    width: 5.469vw;
    height: 5.469vw;
    img {
      width: 4.427vw;
      height: 4.427vw;
    }
  }
`;
export const MainSlidNextButton = styled.button`
  width: 56px;
  height: 56px;
  background: rgba(0, 0, 0, 0.6);
  border: 0 none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  > i {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  img {
    width: 40px;
    height: 40px;
  }
  @media all and (max-width: 900px) {
    width: 48px;
    height: 48px;
    img {
      width: 32px;
      height: 32px;
    }
  }
  @media all and (max-width: 768px) {
    width: 5.469vw;
    height: 5.469vw;
    img {
      width: 4.427vw;
      height: 4.427vw;
    }
  }
`;
